import React from 'react'
import ModalWrapper from './ModalWrapper'
import ImageSearchContainer from '../../containers/modals/ImageSearchContainer'

const ImageSearchModal = props => {
	let title
	let iconName
	if(props.isGif){
		title = 'Select GIF'
		iconName = 'newGIF'
	}
	else{
		title = 'Select Image' 
		iconName = 'newImage'
	}
	return (
    <div className='itemEditor-mediaModal imageSearch-modal'>
      <ModalWrapper
        {...props}
        title={title}
        iconName={iconName}
        modalStyle='light'
      >
        <ImageSearchContainer {...props}/>

      </ModalWrapper>

    </div>

  )
}

export default ImageSearchModal